var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29287 18.7071C7.90237 18.3166 7.90237 17.6834 8.29287 17.2929L13.5858 12L8.29287 6.70708C7.90237 6.31658 7.90237 5.68338 8.29287 5.29288C8.68337 4.90238 9.31657 4.90238 9.70707 5.29288L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70707 18.7071C9.31657 19.0976 8.68337 19.0976 8.29287 18.7071Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.1069f6bd5b664cff226f33ac7a19099a.svg";
export { ForwardRef as ReactComponent };